import { InputAdornment } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Search } from './styles';

interface SearchBarProps {
  search: string;
  setSearch: any;
}

const SearchBar = ({ search, setSearch }: SearchBarProps) => {
  const { t } = useTranslation();

  return (
    <Search
      data-cy="txt-search-post"
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      placeholder={t('COMMON.SEARCH')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src="/assets/icons/blog/search.svg" alt="search" width={24} height={24} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
